import * as Moment from "moment";
import * as React from "react";
import { SignupForm } from "./SignupForm";
Moment.locale("sv");

const App: React.SFC = () => (
  <div>
    <SignupForm />
  </div>
);

export default App;
